import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import buySteps from "../buySteps";

const WishStep_9 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_8);
  };

  const handleYesStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_1);
  };

  const handleNoStep = () => {
    goToStep(buySteps.wishesSteps.buy.step_1);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        yesStep={handleYesStep}
        noStep={handleNoStep}
        text="У вас есть квартира, которую вы планируете продать для покупки новой?"
      />
    </div>
  );
};

export default WishStep_9;
